import * as MobX from "mobx";

// Custom
import { BaseStore } from "./BaseStore";
import { Stores } from "../Stores";
import * as DashboardModel from "Custom/Models/DashboardModel";

export class DashboardStore extends BaseStore {
    @MobX.observable
    private dashboardDetails: DashboardModel.DashboardModelDTO = {
        id: "",
        choicesModifiedDateUTC: "",
        documentsModifiedDateUTC: "",
        progressModifiedDateUTC: "",
        snagsModifiedDateUTC: "",
        inspectionStageModifiedDateUTC: "",
        choicesMadePercentage: 0,
        documentCount: 0,
        snagCount: 0,
        completedSnagCount: 0,
        developmentName: "",
        developmentId: "",
        houseTypeName: "",
        houseTypeImageUrl: "",
        houseTypeThumbnailUrl: "",
        plotNumber: "",
        propertyAddress: "",
        numberOfBeds: 0,
        numberOfBathrooms: 0,
        parkingSpaceCount: 0,
        progressName: "",
        progressColour: "",
        buildStatusName: "",
        buildStatusColour: "",
        inspectionStageName: "",
        availablePlots: [],
        isInTenYearWarranty: false,
        isChoicesLocked: false,
        isChoicesToPlot: false,
        isReportSnags: false,
        isShowPaymentsInCustomerPortal: true,
        isTargetCompletionVisible: false,
        isViewBuildStages: false,
        houseTypeAreas: [],
        warrantyProviderName: "",
        isWarrantyProviderVisibleValue: true,
        warrantyProviderEmail: "",
        warrantyProviderContactNumber: "",
    };

    @MobX.action
    public populateDashboardDetails(dashboardDetails: DashboardModel.DashboardModelDTO) {
        this.dashboardDetails = dashboardDetails;
    }

    @MobX.computed
    public get getDashboardDetails(): DashboardModel.DashboardModelDTO {
        return this.dashboardDetails;
    }

    public Init(stores: Stores) {}
}
